//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "@/mixins/global";
import chartOTP from "../../components/ChartShipment";
import axios, { CancelToken } from "axios";
export default {
  components: {
    chartOTP
  },
  data() {
    return {
      refreshComponent: false,
      G1: true,
      G2: true,
      G3: true,
      G4: true,
      VN: true,
      ps: "",
      pe: "",
      eps: "",
      epe: "",
      customer: "",
      customers: [],
      brand: "",
      brands: [],
      g1: "G1",
      g2: "G2",
      g3: "G3",
      g4: "G4",
      trm: "TRM",
      vn: "NYV1"
    };
  },
  async mounted() {
    let a = await this.defaultPeriod();
    let b = await this.listcustomer();
    let c = await this.listbrand();
    this.loadData();
  },
  methods: {
    defaultPeriod() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board7/perform/defaultweek`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.ps = res.data.ps;
        this.pe = res.data.pe;
        this.eps = res.data.ps;
        this.epe = res.data.pe;
      });

      return obj;
    },
    listcustomer() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board7/perform/customer`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.customers = res.data;
      });

      return obj;
    },
    listbrand() {
      const postjson = {};

      const obj = axios({
        method: "post",
        url: `${this.$apiflask}nygctroom/board7/perform/brand`, // php
        data: postjson
      }).then(res => {
        // console.log(res.data);
        this.brands = res.data;
      });

      return obj;
    },
    ExportData() {
      if (this.eps == "" || this.epe == "") {
        this.$q.notify({
          position: "top-right",
          timeout: 2500,
          textColor: "white",
          color: "red",
          message: "Please fill Week!",
          html: true
        });
        return false;
      } else {
        window.open(
          `${this.$apiflask}nygctroom/board7/perform/export?ps=${this.eps}&pe=${
            this.epe
          }&g1=${this.g1}&g2=${this.g2}&g3=${this.g3}&g4=${this.g4}&trm=${
            this.trm
          }&vn=${this.vn}&uuid=${this.create_UUID()}`,
          "_export"
        );
      }
    },

    loadData() {
      this.refreshComponent = false;
      this.pulling = setTimeout(() => {
        this.refreshComponent = true;
      }, 500);
    }
  }
};
